import React, { useState, useEffect } from "react";

const styles = {
  container: {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
  },
  radioButton: {
    padding: "8px 12px",
    borderRadius: "8px",
    margin: "4px 8px 4px 0",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "background-color 0.3s, color 0.3s",
  },
  approve_selected: {
    background: "#02943e",
    color: "#fff",
    borderColor: "#02943e",
  },
  decline_selected: {
    background: "#94010e",
    color: "#fff",
    borderColor: "#94010e",
  },
  list: {
    listStyleType: "none",
    padding: 0,
    display: "flex",
    textAlign: "center",
  },
};

const CustomRadioButton = ({ label, selected, onSelect, isApprove=true }) => (
  <li>
    <div
      style={{
        ...styles.radioButton,
        ...(isApprove? {border: "2px solid #02943e"}: {border: "2px solid #94010e"}),
        ...(selected ? (isApprove ? styles.approve_selected : styles.decline_selected) : {}),
      }}
      onClick={onSelect}
      onKeyDown={() => {}}
    >
      {label}
    </div>
  </li>
);

const ApprovalChangeForm = ({
  new_form = true
}) => {
  const [selectedValue, setSelectedValue] = useState(0);
  
  useEffect(() => {
    if (!new_form) {
      let submit_btns = document.querySelectorAll("input[name=commit][type=submit]");
      submit_btns.forEach(s_btn => {
        s_btn.disabled = true;
        s_btn.classList.add("opacity-50", "cursor-not-allowed");        
      });
    }
  }, [])


  const handleRadioSelectChange = (value) => {
    setSelectedValue(value);

    let submit_btns = document.querySelectorAll("input[name=commit][type=submit]");

    if (value == 1 || value == 2) {
      submit_btns.forEach(s_btn => {
        s_btn.disabled = false;
        s_btn.classList.remove("opacity-50", "cursor-not-allowed");
      });
    } else {
      submit_btns.forEach(s_btn => {
        s_btn.disabled = true;
        s_btn.classList.add("opacity-50", "cursor-not-allowed");
      });
    }
  };



  return (
    <div>
      <div className="grid sm:grid-cols-6 gap-4 grid-cols-1 w-full items-center mb-8">
        <div className="sm:col-span-2 col-span-1">
          <h3 className="whitespace-nowrap">Status</h3>
        </div>
        <div className="sm:col-span-4 col-span-1">
          <input
            type="hidden"
            name="approval_change[status]"
            id="approval_change_status"
            value={selectedValue}
          />
          <div>
            <div style={styles.container}>
              <ul style={styles.list}>
                <CustomRadioButton
                  label="Approve"
                  selected={selectedValue === 1}
                  onSelect={() => handleRadioSelectChange(1)}
                  isApprove={true}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-6 gap-4 grid-cols-1 w-full items-center mb-8">
        <div className="sm:col-span-2 col-span-1">
          <h3 className="whitespace-nowrap">Message</h3>
        </div>
        <div className="sm:col-span-4 col-span-1 border-gray-200 border-2">
          <textarea
            name="approval_change[message]"
            id="approval_change_message"
            className="w-full"
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default ApprovalChangeForm;
